<div class="row tab-container mt-3">
    <!-- Implemeting tabs  1st tabs-->   
    <div [ngClass]="toggleStatus === 'subTaskDetails' ? 'col-3 tabNewSub p-2 activeNewTimeLine' : 'col-3 tabNewSub p-2'"
        (click)="toggleMode('subTaskDetails')">
        <div class="newAlignTab lbl-text align-tabs">
          <a><mat-icon>assignment</mat-icon> Sub Task Details <mat-icon
              *ngIf="toggleStatus === 'subTaskDetails'">keyboard_arrow_down</mat-icon></a>
        </div>
    </div>
    <!-- 2nd tab -->   
    <div [ngClass]="toggleStatus === 'externalLinks' ? 'col-3 tabNewSub p-2 activeNewTimeLine' : 'col-3 tabNewSub p-2'"
        (click)="toggleMode('externalLinks')">
        <div class="newAlignTab lbl-text align-tabs drafttext">          
          <a><mat-icon>launch</mat-icon> External Links <mat-icon
              *ngIf="toggleStatus === 'externalLinks'">keyboard_arrow_down</mat-icon></a>
        </div>
      </div>
      <!-- 3rd tab -->
      <div [ngClass]="toggleStatus === 'dataLog' ? 'col-2 tabNewSub p-0 activeNewTimeLine' : 'col-2 tabNewSub p-0'"
        (click)="toggleMode('dataLog')">
        <div class="newAlignTab lbl-text align-tabs drafttext">
          <a><mat-icon>schedule</mat-icon> Interaction Log <mat-icon
              *ngIf="toggleStatus === 'dataLog'">keyboard_arrow_down</mat-icon></a>
        </div>
      </div>
  </div>
  <div class="pt-3"></div>

<div *ngIf="toggleStatus === 'externalLinks'" class="pt-2">
  <lib-external-links
    [inputData]="{ fromBenProfile: false, fromTask: true, subTaskType: subTaskDetails.id }"></lib-external-links>
</div>

<div *ngIf="toggleStatus === 'subTaskDetails'" class="pt-3">
  <div class="container-fluid">
    <div class="row col-md-12">
      <!--Sub header -->
      <app-i140-subheader [toggleSubTaskDetailsPanelBtn]="toggleSubTaskDetailsPanel"
        (onStepClick)="handleStepClick($event)" (subTaskPanelToggleEvent)="handleSubTaskPanelToggle($event)"
        class="w-100"></app-i140-subheader>
    </div>
    <p-divider></p-divider>

    <div class="alert alert-warning alert-dismissible fade show" role="alert" *ngIf="taskAllocationUpdateRequired">
      <strong>Recommendation:</strong> Task Allocation needs to be updated
    </div>
    <ng-container *ngIf="toggleSubTaskDetailsPanel">
      <div class="row col-md-12">
        <!-- Sub Header -->
        <ng-container *ngIf="toggleSubTaskDetailsPanel">
          <app-update-sub-task-details style="width:100%"
            (subTaskPanelToggleEvent)="handleSubTaskPanelToggle($event)"></app-update-sub-task-details>
        </ng-container>
      </div>
    </ng-container>

    <!-- Tab View -->
    <div class="row col-md-12 dc-tab-container"
      *ngIf="userType != 'Beneficiary' && subTaskDetails['isOutsideImagility'] != 1 && !toggleSubTaskDetailsPanel">
      <div class="tab-label tab-height" [ngClass]="{'activePetTab': toggleTabText === 'TIMELINE' }">
        <h3 (click)="toggleTabText = 'TIMELINE';"><span class="pi pi-sitemap-big"></span> Timeline </h3>
      </div>
      <div class="tab-label tab-height" [ngClass]="{'activePetTab': toggleTabText === 'DOCUMENT_LIST' }">
        <h3 (click)="toggleTabText = 'DOCUMENT_LIST';preparePrimaryData();"><span class="pi pi-server"></span>Document
          Checklist </h3>
        <div class="help-video-section">
          <help-video-overlay-library #helpVideoComponent></help-video-overlay-library>
        </div>
      </div>
    </div>

    <!-- Tab View -->
    <div class="row col-md-12 timeline-container" *ngIf="toggleTabText === 'TIMELINE' && !toggleSubTaskDetailsPanel">
      <!-- Time line -->
      <app-i140-timeline [inputStepList]="stepList" (onStepClick)="handleStepClick($event)"
        class="w-100"></app-i140-timeline>
    </div>

    <div class="row col-md-12 documents-container"
      *ngIf="toggleTabText === 'DOCUMENT_LIST' && !toggleSubTaskDetailsPanel">
      <div class="w-100 shadow-sm pt-3">
        <!-- <lib-document-checklist-library [primaryData]="primaryData"></lib-document-checklist-library> -->
        <lib-document-checklist-new-library [primaryData]="primaryData"></lib-document-checklist-new-library>
      </div>
    </div>

  </div>
</div>

<div *ngIf="toggleStatus === 'dataLog'" class="container-fluid p-0">  
  <div class="tab-box">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="Notes">        
        <app-add-notes [inputData]="stepList"></app-add-notes>
      </mat-tab>
      <mat-tab label="Data and Document Requests">
        <!-- <app-data-log [dataLogChanges]="dataLogStatus" class="w-100"></app-data-log> -->
      </mat-tab> 
      <mat-tab label="Email">
        <app-interaction-email class="w-100"></app-interaction-email>
      </mat-tab>     
    </mat-tab-group>
  </div> 
</div>

